export const randomInteger = (min = 0, max = 1) =>
  Math.floor(Math.random() * max) + min;

export const randomArrayElement = (arr) => arr[randomInteger(0, arr.length)];

let lastIndex = null;

export const randomArrayElementImplement = (arr) => {
  if (arr.length === 0) return undefined;
  if (lastIndex !== null && Math.random() < 0.3) {
    return arr[lastIndex];
  }
  let newIndex;
  do {
    newIndex = randomInteger(0, arr.length);
  } while (newIndex === lastIndex && arr.length > 1);
  lastIndex = newIndex;
  return arr[newIndex];
};


export const randomDigit = (length) => randomString(length, "0123456789");
export const randomAlphaNumeric = (length) =>
  randomString(
    length,
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  );

export const randomString = (length, characters) => {
  let result = "";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
export const arrayShuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const shuffleAnswer = (answers) => {
  for (let i = answers.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [answers[i], answers[randomIndex]] = [answers[randomIndex], answers[i]];
  }
  return answers;
};

export const RandomWiscousin = () => {
  const avilableColors = ["#F23535", "#27AE60", "#2F80ED"];
  const cons = ["รูปทรง", "สี", "จำนวน"];
  const svgFiles = ["star", "ball", "triangle", "plus"];
  const number = Math.floor(Math.random() * 4) + 1;
  const color =
    avilableColors[Math.floor(Math.random() * avilableColors.length)];
  const symbol = svgFiles[Math.floor(Math.random() * 4)];
  const con = cons[Math.floor(Math.random() * cons.length)];
  const question = {
    condition: con,
    symbol: symbol,
    color: color,
    number: number,
  };

  return question;
};
